module.exports = __webpack_public_path__ + "img/py_icon.c5c442d.png";